export default __webpack_public_path__ + "static/media/task_empty_state.ec382f72.svg";